module.exports = "./dist/fabric_b.svg?efdd61b348dbcb63d89d7d7efb6b197e";


//////////////////
// WEBPACK FOOTER
// ./src/img/fabric_b.svg
// module id = 96
// module chunks = 0